import { Tooltip } from 'antd';
import './Tag.scss';
import { useState } from 'react';
import { cn } from '../../../utils/string/cn.utils';

const Tag = ({ label, tooltip, ...props }) => {
  const [open, setOpen] = useState(false);
  return (
    <Tooltip title={tooltip} open={tooltip && open} color="white">
      <div
        {...props}
        className={cn('tag__table ', props.className)}
        onMouseOver={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        {label}
      </div>
    </Tooltip>
  );
};

export default Tag;
